'use client';

import { useEffect, useState } from 'react';

import { OrderForm } from './OrderForm';

/**
 * Applies `?product=` after mount so the buy page can stay statically
 * exported without a `useSearchParams` Suspense boundary (which caused CLS
 * when the fallback swapped for the real form).
 */
export function OrderFormGate({ fallbackProductId }: { fallbackProductId?: string }) {
  const [productId, setProductId] = useState(fallbackProductId);

  useEffect(() => {
    const fromQuery = new URLSearchParams(window.location.search).get('product');
    if (fromQuery) setProductId(fromQuery);
  }, []);

  return <OrderForm initialProductId={productId} />;
}
